export default "__VITE_ASSET__B$5i_$0b__"